// extracted by mini-css-extract-plugin
module.exports = {"loadScreen":"LoadScreen_loadScreen__34DAO","spinner":"LoadScreen_spinner__1bEG0","load":"LoadScreen_load__aIRqb"};